<template>
  <b-row align-h="end" class="advise-map">
    <b-col sm="5" align-self="end">
      <b-alert :variant="variantdata" show>
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        {{ mess }}
        </b-alert>
    </b-col>
    <b-col lg="4">
        <!-- <b-button @click="showModal(true)">Cancelar</b-button>
        <b-button @click="filterArea">Aceptar</b-button>
        <b-button @click="addPolygon">Añadir</b-button> -->
        <b-button v-if='!view' :pressed='(clicked == "add") ? true : false' @click="add">Dibujar área</b-button>
        <b-button v-if='!view' :pressed='(clicked == "select") ? true : false' @click="select">Seleccionar área</b-button>
        <b-button v-if='!view' :pressed='(clicked == "cancel") ? true : false' @click="cancel">Cancelar</b-button>
        <b-button :pressed='(clicked == "accept") ? true : false' @click="accept">Aceptar</b-button>
    </b-col>
  </b-row>
</template>

<style>
.advise-map{
  position: absolute;
  top:50px;
  width:100%;
  padding-left:200px;
  /*margin-bottom: -50px;*/
  z-index:3;
}
</style>
<script>
export default {
  props: ['message', 'variant', 'view'],
  data () {
    return {
      clicked: null,
      mess: 'Pulse sobre el área para borrarla',
      variantdata: 'warning'
    };
  },
  methods: {
    accept () {
      this.$emit('accept');
      this.clicked = 'accept';
    },
    cancel () {
      this.clicked = 'cancel';
      this.$emit('cancel');
    },
    add () {
      this.clicked = 'add';
      this.$emit('add');
    },
    select () {
      this.clicked = 'select';
      this.$emit('select');
    }
  },
  mounted () {
    if (this.view) {
      this.mess = "Pulse sobre el botón 'Aceptar' para salir";
    } else if (this.message) {
      this.mess = this.message;
    }

    if (this.variant) { this.var = this.variant; }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Modules/Map/Area.vue